module.exports = __webpack_public_path__ + "media/22.c753cd55.mp4";